/*
 * Copyright (c) 2023. Haodong JU
 */

import hillo from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import dayjs from 'dayjs'

const entity = {
  id: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      required: false
    },
    header: false
  },
  zbonNumber: {
    displayName: 'ZbonNumber'
  },
  fromTimestamp: {
    displayName: 'startsAt',
    type: IKDataEntity.Types.Date
  },
  toTimestamp: {
    displayName: 'endsAt',
    type: IKDataEntity.Types.Date
  },
  createTimestamp: {
    displayName: 'createdAt'
  },
  reprint: {
    tableConfig: { overwrite: true },
    displayName: 'operation'
  }
}
const config = {
  load: async function (filter) {
    const [timeStart, timeEnd] = [dayjs(filter[0].dateFilter[0]).subtract(1, 'day').format('YYYY-MM-DD') + ' 04:00:01', dayjs(filter[0].dateFilter[1]).add(1, 'day').format('YYYY-MM-DD') + ' 03:59:59']
    return (await hillo.get('ZBon.php?op=searchZbonCombinedRecord', {
      fromDateTime: timeStart,
      toDateTime: timeEnd
    }))
      .content
      .filter(it => dayjs(it.toTimestamp).format('YYYY-MM-DD') !== dayjs(timeStart).format('YYYY-MM-DD'))
  }
}

export default IKDataEntity.ModelFactory(entity, config)
